import { useTranslation } from 'react-i18next';

import Modal from '../../../components/Modal/Modal';
import InsightsDashboard from './components/InsightsDashboard';
import InsightsDashboardCoefficients from './components/InsightsDashboardCoefficients';

import type { IInsightsDashboardProps } from './interfaces/IInsightsDashboardProps';

import styles from './scss/MAInsightsDashboard.module.scss';

function MaterialAssessmentInsightsDashboardView({
  control,
  dashboardData,
  templatesData,
  dashboardTopics,
  showActionButtons,
  isSliderWrapper,
  onClearAll,
  onGenerate,
  setSliderWrapper,
  coefficientData,
  isBackModalOpen,
  setIsBackModalOpen,
  isResetModalOpen,
  onHandleReset,
  onHandleResetConfirm,
  onHandleBack,
  onHandleBackConfirm,
  setValue,
  fields,
  update,
  onSaveCoefficients,
  isSetImpactLoading,
  handleCancelDashboard,
  handleNext,
  options,
  handlePrev,
}: IInsightsDashboardProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      {isSliderWrapper
        ? (
          <InsightsDashboardCoefficients
            control={control}
            onHandleBack={onHandleBack}
            onHandleReset={onHandleReset}
            coefficientData={coefficientData}
            setValue={setValue}
            fields={fields}
            update={update}
            onSaveCoefficients={onSaveCoefficients}
            isSetImpactLoading={isSetImpactLoading}
          />
        )
        : (
          <InsightsDashboard
            control={control}
            dashboardData={dashboardData}
            templatesData={templatesData}
            dashboardTopics={dashboardTopics}
            showActionButtons={showActionButtons}
            onClearAll={onClearAll}
            onGenerate={onGenerate}
            setSliderWrapper={setSliderWrapper}
            handleCancelDashboard={handleCancelDashboard}
            handleNext={handleNext}
            setValue={setValue}
            options={options}
            handlePrev={handlePrev}
          />
        )}
      <Modal
        open={isBackModalOpen}
        title={t('createNewUser.cancelModalTitle')}
        description={t('clients.cancelModalText')}
        confirmTitle={t('common.discardChanges')}
        closeTitle={t('common.keepEditing')}
        confirmVariant="error"
        onClose={() => setIsBackModalOpen(false)}
        onReject={() => setIsBackModalOpen(false)}
        onConfirm={onHandleBackConfirm}
      />
      <Modal
        open={isResetModalOpen}
        title={t('materialityAssessment.resetCoefficients')}
        description={t('materialityAssessment.resetCoefficientDescription')}
        confirmTitle={t('materialityAssessment.yesReset')}
        closeTitle={t('materialityAssessment.no')}
        confirmVariant="error"
        onClose={() => onHandleReset(false)}
        onReject={() => onHandleReset(false)}
        onConfirm={onHandleResetConfirm}
      />
    </div>
  );
}

export default MaterialAssessmentInsightsDashboardView;
